var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('footer',{staticClass:"footer"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12 footer-copyright text-center"},[_c('p',{staticClass:"mb-0"},[_vm._v("Copyright 2024 © Future Bangaldesh You Want by Catch Bangladesh")])])])])])])
}]

export { render, staticRenderFns }